import { Suspense, useEffect } from 'react';

import { logOutFun } from 'features/auth/slice';
import { hideAlert, showAlert } from 'features/alert/slice';
import { useAppDispatch } from 'app/hooks';

import LayoutManager from './Layouts';

import Api from 'utils/api';

function App() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        Api.interceptors.request.use(
            (config) => {
                const auth_token = localStorage.getItem('access_token') || '';

                if (config.headers && auth_token) {
                    config.headers.Authorization = `Bearer ${auth_token}`;
                }

                return config;
            },
            (error) => {
                return Promise.reject(error);
            },
        );

        Api.interceptors.response.use(
            (response) => {
                return response;
            },
            (ex) => {
                if (ex.response.status === 401) {
                    dispatch(logOutFun());

                    return Promise.reject(ex);
                }

                let message = ex.message;

                if (
                    ex &&
                    ex.response &&
                    ex.response.data &&
                    ex.response.data.error
                ) {
                    message = ex.response.data.error;
                }

                if (
                    ex &&
                    ex.response &&
                    ex.response.data &&
                    ex.response.data.errors
                ) {
                    message = Object.keys(ex.response.data.errors)
                        .map((err) => {
                            return ex.response.data.errors[err].join('\n');
                        })
                        .join('\n');
                }

                dispatch(
                    showAlert({
                        status: 'error',
                        title: 'Failed',
                        message: message,
                    }),
                );

                setTimeout(() => {
                    dispatch(hideAlert());
                }, 5000);

                return Promise.reject(ex);
            },
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <LayoutManager />
        </Suspense>
    );
}

export default App;
